import { useTranslation } from 'react-i18next';

import { useUser } from '../../../../../../hooks/useUser';
import { UserRole } from '../../../../../../types/user';
import { MAX_NUMBER_OF_YEARS_IN_THE_FUTURE } from '../../../../utils/validation';

export const useSolcellerValidation = () => {
  const { t } = useTranslation();
  const { user } = useUser();

  const validateTilt = (value?: number) => {
    if (!value) {
      return t('register.solar.form.panel.tilt.missing');
    }
    if (value > 90 || value < 0) {
      return t('register.solar.form.panel.tilt.invalid');
    }
    return true;
  };

  const validateAzimuth = (value?: number) => {
    if (!value) {
      return t('register.solar.form.panel.azimuth.missing');
    }
    if (value > 360 || value < 0) {
      return t('register.solar.form.panel.azimuth.invalid');
    }
    return true;
  };

  const validateArea = (value?: number) => {
    if (!value) {
      return t('register.solar.form.panel.area.missing');
    }
    if (value > 10000 || value < 0) {
      return t('register.solar.form.panel.area.invalid');
    }
    return true;
  };

  const validateKwp = (value?: number) => {
    if (!value) {
      return t('register.solar.form.panel.effect.missing');
    }
    if (value > 100) {
      return t('register.solar.form.panel.effect.invalid');
    }
    return true;
  };

  const validateKwh = (value?: number) => {
    if (!value) {
      return t('register.solar.form.productionData.error');
    }

    if (value > 100000) {
      return t('register.solar.form.productionData.invalid');
    }
    return true;
  };

  const validateYear = (value?: string) => {
    if (!value) {
      return t('register.solar.form.installationYear.missing');
    }

    const allowedFutureYears = user?.rolle === UserRole.PROFESJONELL ? MAX_NUMBER_OF_YEARS_IN_THE_FUTURE : 0;
    const currentYear = new Date().getFullYear();

    if (parseInt(value) > currentYear + allowedFutureYears) {
      return t('register.solar.form.installationYear.invalid');
    }

    return true;
  };

  const decimalPattern = {
    value: /^\d+(?:[.,]\d{1,2})?$/,
    message: t('form.error.decimal')
  };

  const integerPattern = {
    value: /^\d+$/,
    message: t('form.error.integer')
  };

  const yearPattern = {
    value: /^(19|20)\d{2}$/,
    message: t('register.solar.form.installationYear.invalid')
  };

  return {
    integerPattern,
    decimalPattern,
    yearPattern,
    validateTilt,
    validateAzimuth,
    validateArea,
    validateKwh,
    validateKwp,
    validateYear
  };
};
